import RtReconciliationUploadRtReportRequestBase from './base/RtReconciliationUploadRtReportRequestBase';

/**
 * @class RtReconciliationUploadRtReportRequest
 * @extends RtReconciliationUploadRtReportRequestBase
 */
class RtReconciliationUploadRtReportRequest extends RtReconciliationUploadRtReportRequestBase {

}

export default RtReconciliationUploadRtReportRequest;
